export default __webpack_public_path__ + "static/media/pharmbio-logo.ceae977b.png";